import Http from "../../service/api";
import { judgeIsSplice } from "../../common/utils";

// -----------------------------  考试信息  -------------------------
/**
 * 外部用户获取考试集合 get query
 * @param {*} params 
 */
export async function getExternalExamList(params: any) {
  return Http.get(`/public/v1/exam/external/list&`, params);
}
// -----------------------------  考试对内  -------------------------
/**
 * 内部用户获取考试集合 get query
 * @param {*} params 
 */
export async function getInternalExamList(params: any) {
  return Http.get(`/v1/exam/internal/list${judgeIsSplice()}`, params);
}
/**
 * 内部用户获取已经参与的考试 get query
 * @param {*} params 
 */
export async function getInternalExam(params: any) {
  return Http.get(`/v1/exam/internal/examlist${judgeIsSplice()}`, params);
}
/**
 * 内部用户获取考试集合 get query
 * @param {*} params 
 */
export async function getInternalExamInfo(params: any) {
  return Http.get(`/v1/exam/internal/info${judgeIsSplice()}`, params);
}
/**
 * 内部用户获取考试账户 get query
 * @param {*} params 
 */
export async function getInternalAccount(params: any) {
  return Http.get(`/v1/exam/internal/getaccount${judgeIsSplice()}`, params);
}
/**
 * 外部用户获取考试账户 get query
 * @param {*} params 
 */
export async function getExternalAccount(params: any) {
  return Http.get(`/public/v1/exam/external/info`, params);
}
/**
 * 外部用户报名考试 post formData
 * @param {*} params 
 */
export async function signExamExternal(params: any) {
  return Http.post(`/public/v1/exam/external/sign`, params, 'formData');
}
// -----------------------------  对内证书  -------------------------
/**
 * 内部用户自己获取证书集合 get query
 * @param {*} params 
 */
export async function getInternalCert(params: any) {
  return Http.get(`/v1/cert/internal/list${judgeIsSplice()}`, params);
}
/**
 * 用户分页条件获取未绑定的证书 get query
 * @param {*} params 
 */
export async function getUserCert(params: any) {
  return Http.get(`/v1/cert/user/list${judgeIsSplice()}`, params);
}
/**
 * 用户绑定证书 put formData
 * @param {*} params 
 */
export async function userBindCert(params: any) {
  return Http.put(`/v1/cert/user/binding${judgeIsSplice()}`, params, 'formData');
}

// -----------------------------
// 获取考试记录列表
export async function getExamListRecord(params: any) {
  return Http.get(`/api/v1/exam/listRecord${judgeIsSplice()}`, params);
}
// 根据人员id查询证书合集
export async function getExamCert(params: any) {
  return Http.get(`/api/v1/exam/getCertByUserID${judgeIsSplice()}`, params);
}
// 检查考试资格
export async function checkExam(params: any) {
  return Http.get(`/api/v1/exam/check${judgeIsSplice()}`, params);
}
